import { render, staticRenderFns } from "./zzTest.vue?vue&type=template&id=1b7da30c&scoped=true"
import script from "./zzTest.vue?vue&type=script&lang=js"
export * from "./zzTest.vue?vue&type=script&lang=js"
import style0 from "./zzTest.vue?vue&type=style&index=0&id=1b7da30c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7da30c",
  null
  
)

export default component.exports